import React from 'react';
import { useIntl } from 'ha/i18n';

import { Grid } from '@hbf/dsl';
import { Banner } from 'ha/ui.legacy/Banner';

const ListingNotAvailableBanner: React.FC = () => {
  const { T } = useIntl();

  return (
    <Banner
      bg="purple"
      color="white"
      data-test-locator="Listing/Not Available Banner"
    >
      <Grid container justifyContent="center" alignItems="center">
        {T('This listing is not available anymore')}
      </Grid>
    </Banner>
  );
};

export { ListingNotAvailableBanner };
